import { CMSCTA } from "../models";


export enum ShortcodeTypes {
    LINK = 'LINK'
}
export type ShortcodeType = `${ShortcodeTypes}`
export interface Shortcode  extends Record<string, string> {
    type: `${ShortcodeTypes}`,
    
}

export type ShortcodeArray = [ShortcodeType, ...string[]];

export interface ShortcodeLink extends Pick<CMSCTA, 'color' | 'scope' | 'scopeParameters' | 'href'> {
    type: 'LINK',
    title: string
}

export function isShortCodeLink(shortCode: any): shortCode is ShortcodeLink {
    return shortCode.type === 'LINK'
}

export function isShortcodeArray(arr: string[] = []): arr is ShortcodeArray {
    return arr[0] in ShortcodeTypes
}